import React from 'react'
import {
    Flex,
    Menu,
    MenuButton,
    Text,
    MenuList,
    MenuItem,
    Button,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {ChevronDown} from '../../icons'
import Checkbox from '../../../components/checkbox'
import {useLocation, useHistory} from 'react-router-dom'
import {remCalc} from '../../../theme/_utils'

const RecipeMenuButton = ({filter, selectedFilters}) => {
    const styles = useMultiStyleConfig('Filters', {variant: 'recipesFilters'})
    const location = useLocation()
    const history = useHistory()

    const handleFilterSelection = ({fieldUID, option}) => {
        const current = selectedFilters[fieldUID] || []
        const exists = current.some((item) => item?.contentstackValue === option)
        const updatedCategory = exists
            ? current.filter((item) => item.contentstackValue !== option)
            : [...current, {contentstackValue: option}]

        const newFilterState = {
            ...selectedFilters,
            [fieldUID]: updatedCategory,
        }
        const searchParams = new URLSearchParams(location.search)
        if (updatedCategory?.length > 0) {
            searchParams.set(fieldUID, updatedCategory?.map((f) => f.contentstackValue).join(','))
        } else {
            searchParams.delete(fieldUID)
        }

        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        })

        return newFilterState
    }

    return filter ? (
        <Menu closeOnSelect={false}>
            {({isOpen}) => (
                <>
                    <MenuButton
                        as={Button}
                        rightIcon={
                            <ChevronDown
                                {...styles.filterIcon}
                                style={{
                                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                }}
                            />
                        }
                        {...styles.filterButton}
                        {...styles.refinementsSelectorButton}
                    >
                        <Text {...styles.filterText}>{filter?.name}</Text>
                    </MenuButton>
                    <MenuList {...styles.filterOpenMenu}>
                        {filter?.options?.length > 0 &&
                            filter?.options?.map((option, idx) => {
                                return (
                                    <MenuItem
                                        key={`${filter?.fieldUID}-menu-option-${idx}`}
                                        paddingTop="unset"
                                        paddingX="unset"
                                        paddingBottom="medium.base"
                                        _focus={{background: 'unset'}}
                                        _hover={{background: 'unset'}}
                                    >
                                        <Flex
                                            w="100%"
                                            maxWidth={remCalc(200)}
                                            justifyContent="space-between"
                                        >
                                            <Text>{option?.contentstackValue}</Text>
                                            <Checkbox
                                                onChange={() => {
                                                    handleFilterSelection({
                                                        fieldUID: filter?.fieldUID,
                                                        option: option?.contentstackValue,
                                                    })
                                                }}
                                                isChecked={
                                                    selectedFilters[filter?.fieldUID]?.some(
                                                        (f) =>
                                                            f.contentstackValue ===
                                                            option.contentstackValue,
                                                    ) || false
                                                }
                                            />
                                        </Flex>
                                    </MenuItem>
                                )
                            })}
                    </MenuList>
                </>
            )}
        </Menu>
    ) : (
        <></>
    )
}

RecipeMenuButton.propTypes = {
    filter: PropTypes.object.isRequired,
    selectedFilters: PropTypes.object.isRequired,
}

export default RecipeMenuButton
